$('.Buttons button').click(function () {
  $(this).addClass('active').siblings().removeClass('active');  
  let text = $(this).text().toLowerCase();
  let loop_target = $(this).closest('.Products_loop').find('.product_data');  
  loop_target.each(function () {
    let titles = $(this).find('span').text().toLowerCase();    
    // Create regex for whole word match
    let regex = new RegExp(`\\b${text}\\b`, 'i');
    if (text === 'all' || regex.test(titles)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
});

document.querySelectorAll('.Products_loop input#fname').forEach((searchInput) => {
  searchInput.addEventListener("input", function () {
    const searchValue = this.value.toLowerCase();
    const loopTarget = this.closest('.Products_loop').querySelectorAll('.product_data');
    loopTarget.forEach((product) => {
      const title = product.querySelector('span')?.textContent.toLowerCase() || '';
      product.style.display = title.includes(searchValue) ? 'flex' : 'none';
    });
  });
});


function all_titles(text,index) {
  let input_bundle = $('.product-info__buy-buttons input[name="properties[_bundle_selection]"]')
  if(input_bundle){
    console.log(index,'ssssssssss')
    let selections = input_bundle.val().split('<>');
    selections = selections.map(item => item.trim());
    selections[index] = text;
    input_bundle.val(selections.join(' <> '));
  }  
}
$('.Products_loop .product_data').click(function (params) {
  let text = $(this).text()
  let src =  $(this).find('img').attr('src')
  let data = $(this).parents('.First_collection').attr('data-tab')
  let num = parseInt($(this).parents('.First_collection').attr('data-index'))+1
  all_titles(text,num)
  $(this).parents('.First_collection').addClass('added')
  $(this).parents('.First_collection').find('.Tabs_header .btn-content-thumbnail .product-title-placeholder').text(text)
  $(this).parents('.First_collection').removeClass('activated')
  $(`.product-info__buy-buttons input[name="properties[${data}]"]`).val(text)
  $(this).parents('.First_collection').next().removeClass('disabled')  
  if($('.First_collection').length===$('.First_collection.added').length){
     $('.product-info__buy-buttons button.button.button--xl.button--secondary').removeAttr('disabled', 'disabled');
  }
})
$('.First_collection .Tabs_header').click(function (params) {
    $(this).parents('.First_collection').toggleClass('activated')
})
$(document).on('click', function (event) {
  if (!$(event.target).closest('.First_collection').length) {
    $('.First_collection').removeClass('activated');
  }
});
$(document).ready(function () {
  let input_bundle = $('div#InserBuild');
  if (input_bundle.length) {
    console.log('testing');
    $('.product-info__buy-buttons button.button.button--xl.button--secondary').attr('disabled', 'disabled');
  }
});
